import React from 'react';
import { Link } from 'react-router-dom';
import { GraduationCap } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';

const STEPS = [
  { id: 1, label: 'Account' },
  { id: 2, label: 'Verify OTP' },
  { id: 3, label: 'School Details' },
];

export default function RegisterLayout({ step, title, description, children }) {
  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-gradient-to-br from-slate-950 via-blue-950 to-slate-900">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-blue-600/20 via-transparent to-transparent pointer-events-none" />
      <Card className="w-full max-w-lg relative z-10 bg-card/90 backdrop-blur-xl border-border/60 shadow-2xl">
        <CardHeader className="text-center pb-2">
          <div className="mx-auto mb-4 w-16 h-16 bg-blue-600 rounded-2xl flex items-center justify-center shadow-lg">
            <GraduationCap className="w-9 h-9 text-foreground" />
          </div>
          <CardTitle className="text-2xl font-bold text-foreground">{title}</CardTitle>
          {description && (
            <CardDescription className="text-muted-foreground">{description}</CardDescription>
          )}
          <div className="mt-4 flex justify-center gap-2">
            {STEPS.map((s) => (
              <div
                key={s.id}
                className={`h-2 flex-1 max-w-16 rounded-full transition-colors ${
                  s.id <= step ? 'bg-blue-500' : 'bg-muted'
                }`}
                title={s.label}
              />
            ))}
          </div>
          <p className="text-xs text-muted-foreground mt-2">
            Step {step} of 3 — {STEPS[step - 1]?.label}
          </p>
        </CardHeader>
        <CardContent>{children}</CardContent>
        <p className="text-center text-sm text-muted-foreground pb-6">
          Already have an account?{' '}
          <Link to="/login" className="text-blue-400 hover:text-blue-300 font-medium">
            Sign in
          </Link>
        </p>
      </Card>
    </div>
  );
}
